module.exports = __webpack_public_path__ + "static/media/graficos.b3128767.jpeg";